import React, { useState, useMemo } from 'react'
import './NavigationBar.css'
import { Link, useLocation } from 'react-router-dom'

const IS_DEV = process.env.NODE_ENV === 'development' // dev-server only; removed from production builds

const SOCIAL_LINKS = [
  {
    label: 'Goodreads',
    href: 'https://www.goodreads.com/user/show/161190325-quinn-thomas',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M11.43 23.995c-3.608-.208-6.274-2.077-6.448-5.078.695.007 1.375-.013 2.07-.006.224 1.342 1.065 2.43 2.683 3.026 1.583.496 3.737.46 5.082-.174 1.351-.636 2.145-1.822 2.503-3.577.212-1.042.236-1.734.231-2.92l-.005-1.631h-.059c-1.245 2.564-3.315 3.53-5.59 3.475-5.74-.054-7.68-4.534-7.528-8.606.01-5.241 3.22-8.537 7.557-8.495 2.354-.14 4.605 1.362 5.554 3.37l.059.002.002-2.918 2.099.004-.002 15.717c-.193 7.04-4.376 7.89-8.209 7.811zm6.1-15.633c-.096-3.26-1.601-6.62-5.503-6.645-3.954-.017-5.625 3.592-5.604 6.85-.013 3.439 1.643 6.305 4.703 6.762 4.532.591 6.551-3.411 6.404-6.967z" />
      </svg>
    ),
  },
  {
    label: 'Amazon',
    href: 'https://www.amazon.com/stores/Quinn-Thomas/author/B0BS493VHK?ref=ap_rdr&store_ref=ap_rdr&isDramIntegrated=true&shoppingPortalEnabled=true',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M.045 18.02c.072-.116.187-.124.348-.022 3.636 2.11 7.594 3.166 11.87 3.166 2.852 0 5.668-.533 8.447-1.595l.315-.14c.138-.06.234-.1.293-.13.226-.088.39-.046.525.13.12.174.09.336-.12.48-.256.19-.6.41-1.006.654-1.244.743-2.64 1.316-4.185 1.726a17.617 17.617 0 01-10.951-.577 17.88 17.88 0 01-5.43-3.35c-.1-.074-.151-.15-.151-.22 0-.047.021-.09.051-.13zm6.565-6.218c0-1.005.247-1.863.743-2.577.495-.71 1.17-1.25 2.04-1.615.796-.335 1.756-.575 2.912-.72.39-.046 1.033-.103 1.92-.174v-.37c0-.93-.105-1.558-.3-1.875-.302-.43-.78-.65-1.44-.65h-.182c-.48.046-.896.196-1.246.46-.35.27-.575.63-.675 1.096-.06.3-.206.465-.435.51l-2.52-.315c-.248-.06-.372-.18-.372-.39 0-.046.007-.09.022-.15.247-1.29.855-2.25 1.82-2.88.976-.616 2.1-.975 3.39-1.05h.54c1.65 0 2.957.434 3.888 1.29.135.15.27.3.405.48.12.165.224.314.283.45.075.134.15.33.195.57.06.254.105.42.135.51.03.104.062.3.076.615.01.313.02.493.02.553v5.28c0 .376.06.72.165 1.036.105.313.21.54.315.674l.51.674c.09.136.136.256.136.36 0 .12-.06.226-.18.314-1.2 1.05-1.86 1.62-1.963 1.71-.165.135-.375.15-.63.045a6.062 6.062 0 01-.526-.496l-.31-.347a9.391 9.391 0 01-.317-.42l-.3-.435c-.81.886-1.603 1.44-2.4 1.665-.494.15-1.093.227-1.83.227-1.11 0-2.04-.343-2.76-1.034-.72-.69-1.08-1.665-1.08-2.94l-.05-.076zm3.753-.438c0 .566.14 1.02.425 1.364.285.34.675.512 1.155.512.045 0 .106-.007.195-.02.09-.016.134-.023.166-.023.614-.16 1.08-.553 1.424-1.178.165-.28.285-.58.36-.91.09-.32.12-.59.135-.8.015-.195.015-.54.015-1.005v-.54c-.84 0-1.484.06-1.92.18-1.275.36-1.92 1.17-1.92 2.43l-.035-.02zm9.162 7.027c.03-.06.075-.11.132-.17.362-.243.714-.41 1.05-.5a8.094 8.094 0 011.612-.24c.14-.012.28 0 .41.03.65.06 1.05.168 1.172.33.063.09.099.228.099.39v.15c0 .51-.149 1.11-.424 1.8-.278.69-.664 1.248-1.156 1.68-.073.06-.14.09-.197.09-.03 0-.06 0-.09-.012-.09-.044-.107-.12-.064-.24.54-1.26.806-2.143.806-2.64 0-.15-.03-.27-.087-.344-.145-.166-.55-.257-1.224-.257-.243 0-.533.016-.87.046-.363.045-.7.09-1 .135-.09 0-.148-.014-.18-.044-.03-.03-.036-.047-.02-.077 0-.017.006-.03.02-.063v-.06z" />
      </svg>
    ),
  },
]

const NAV_LINKS = [
  { label: 'Home', path: '/', key: '' },
  { label: 'Books', path: '/books', key: 'books' },
  { label: 'About', path: '/about', key: 'about' },
  { label: 'Recommendations', path: '/recommended', key: 'recommended' },
]

function NavigationBar({ subscriptionUrl = 'https://substack.com/@quinnthomasauthor' }) {
  const [selectedLink, setSelectedLink] = useState(null)
  const location = useLocation()

  const pathName = useMemo(() => {
    if (selectedLink !== null) {
      return selectedLink
    }
    return location.pathname.split('/')[1] || ''
  }, [location.pathname, selectedLink])

  const toggle = (selected) => setSelectedLink(selected)

  return (
    <header className="site-header">
      <div className="utility-bar">
        <div className="utility-bar-inner">
          <div className="social-links">
            {SOCIAL_LINKS.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={link.label}
              >
                {link.icon}
              </a>
            ))}
          </div>
          <a
            href={subscriptionUrl}
            className="subscribe-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Sign up for my newsletter
          </a>
          {IS_DEV && (
            <Link to="/admin" className="dev-admin-link" onClick={() => toggle('admin')}>
              Admin (dev only)
            </Link>
          )}
        </div>
      </div>

      <nav className="main-nav">
        <div className="main-nav-inner">
          <div>
          <img src="./logo.jpeg" className="logo"/>
          <Link to="/" className="site-brand" onClick={() => toggle('')}>
            Quinn Thomas
          </Link>
          </div>
          <ul className="nav-links">
            {NAV_LINKS.map((link) => {
              const isActive = pathName === link.key
              return (
                <li key={link.key || 'home'}>
                  <Link
                    to={link.path}
                    className={`nav-link${isActive ? ' nav-link-active' : ''}`}
                    onClick={() => toggle(link.key)}
                  >
                    {link.label}
                  </Link>
                </li>
              )
            })}
          </ul>
        </div>
      </nav>
    </header>
  )
}

export default NavigationBar
